/**
 * V3 — Login Page. Google Auth via Emergent.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import React from 'react';
import { useV3Auth } from './auth';
import { Navigate } from 'react-router-dom';

export default function V3Login() {
  const { user, loading } = useV3Auth();

  if (loading) {
    return <V3LoadingScreen />;
  }
  if (user) {
    return <Navigate to="/v3/dashboard" replace />;
  }

  const handleLogin = () => {
    const redirectUrl = window.location.origin + '/v3/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="v3-login-shell">
      <div className="v3-login-grain"></div>
      <div className="v3-login-card">
        <div className="v3-login-brand">
          <div className="v3-login-logo">
            <span className="v3-logo-mark">RO</span>
            <span className="v3-logo-dot"></span>
          </div>
          <div className="v3-login-title">
            <h1>GROUPE ROPS</h1>
            <p>Espace Direction · Tableau de bord moderne</p>
          </div>
        </div>

        <div className="v3-login-divider"></div>

        <p className="v3-login-intro">
          Connectez-vous avec votre compte Google professionnel pour accéder aux
          tableaux de bord en lecture seule.
        </p>

        <button
          onClick={handleLogin}
          className="v3-google-btn"
          data-testid="v3-google-login-btn"
        >
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span>Continuer avec Google</span>
        </button>

        <div className="v3-login-footer">
          <p>Accès réservé · Équipe Direction GROUPE ROPS</p>
          <p>
            Utilisateur de l&apos;app legacy ?{' '}
            <a href="/legacy-v2.html">Connexion classique →</a>
          </p>
          <p style={{ marginTop: 14, fontSize: 11, opacity: 0.7 }}>
            <a
              href="/status"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="v3-status-link"
              style={{ color: 'inherit', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 6 }}
            >
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#22c55e', display: 'inline-block', boxShadow: '0 0 6px rgba(34,197,94,0.6)' }}></span>
              État de la plateforme
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

function V3LoadingScreen() {
  return (
    <div className="v3-login-shell">
      <div className="v3-loading-spinner"></div>
    </div>
  );
}
